export const academyTestimonials = [
  { name: 'Domingo D. - El Salvador', loomIds: ['f272114bfb6c4fee8746a230faa614ec'] },
  {
    name: 'Ángeles - México Puerto Vallarta',
    loomIds: ['ca69ddffb8c2479182926191bfb6f87d'],
  },
  { name: 'Melvin A. - El Salvador', loomIds: ['8b25f1eb168d43fba0a2d810b6d26e4d'] },
  { name: 'Yazmin M. - México', loomIds: ['7d7c5b2ac6c64eaf9dd9c4ab3155db7b'] },
  { name: 'Marcelo E. - El Salvador', loomIds: ['7defc5ce9cd04e878fb4d5ac397fb4bc'] },
  {
    name: 'Josue C - El Salvador',
    loomIds: ['9af1b13541274df19e2d8378e917d23c'],
  },
  { name: 'Manuel A. - El Salvador', loomIds: ['f006031d07bf4dd787ecd589c6fa369b'] },
  { name: 'Santos M. - El Salvador', loomIds: ['dcfd2304d3f148298a4c99f96c355c9b'] },
  {
    name: 'Juan M - El Salvador',
    loomIds: ['e3cea567353a43968e1008357cdc1be7'],
  },
]
